import { shopApi } from "../api";
import { ICategory } from "../../Utils/types";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";

interface ICategoriesState {
  categories: ICategory[],

}
const categoriesState: ICategoriesState = {
  categories: [],
}

// Action types
export const SET_CATEGORIES = 'shop/SET_CATEGORIES';
export const ADD_CATEGORY = 'categories/ADD_CATEGORY';
export const REMOVE_CATEGORY = 'categories/REMOVE_CATEGORY';
export const PATCH_CATEGORY = 'categories/PATCH_CATEGORY';


// Selectors
export const categoriesSelector = (state: any) => state.categories.categories;


// Reducer
export function categoriesReducer(state: ICategoriesState = categoriesState, action: any) {
  switch (action.type) {
    case SET_CATEGORIES: {
      return {
        ...state,
        categories: [...action.payload]
      }
    }

    case ADD_CATEGORY: {
      return {
        ...state,
        categories: [
          ...state.categories,
          action.payload
        ]
      }
    }

    case REMOVE_CATEGORY: {
      const removeId = state.categories.findIndex((item) => {
        return (item.id === action.payload);
      });

      let newRemovecategories = [...state.categories];
      newRemovecategories.splice(removeId, 1);

      return {
        ...state,
        categories: newRemovecategories
      }
    }

    case PATCH_CATEGORY: {
      const patchId = state.categories.findIndex((item) => {
        return (item.id === action.id);
      });

      let newPatchcategories = [...state.categories];
      newPatchcategories[patchId].name = action.name;

      return {
        ...state,
        categories: newPatchcategories
      }
    }

    default: {
      return state
    }
  }
}

// Actions
interface GetCategoriesType {
  type: typeof SET_CATEGORIES,
  payload: ICategory[]
}
export function getCategories(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    const response = await shopApi.getCategories();
    dispatch({
      type: SET_CATEGORIES,
      payload: response.categories
    });
  }
}

interface AddNewCategoryType {
  type: typeof ADD_CATEGORY,
  payload: {
    id: number,
    name: string
  }
}
export function addNewCategory(value: string): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    const category = await shopApi.newCategory(value);
    dispatch({
      type: ADD_CATEGORY,
      payload: {
        id: category.id,
        name: value
      }
    });
  }
}

interface RemoveCategoryType {
  type: typeof REMOVE_CATEGORY,
  payload: number
}
export function removeCategory(id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    await shopApi.removeCategory(id);
    dispatch({
      type: REMOVE_CATEGORY,
      payload: id
    });
  }
}

interface PatchCategoryType {
  type: typeof PATCH_CATEGORY,
  name: string,
  id: number
}
export function patchCategory(newName: string, id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    await shopApi.patchCategory(newName, id);
    dispatch({
      type: PATCH_CATEGORY,
      name: newName,
      id
    });
  }
}

export type CategoriesActions =
  PatchCategoryType
  | RemoveCategoryType
  | AddNewCategoryType
  | GetCategoriesType;